<div [formGroup]="group">
	<div class="row" formGroupName="contactDetails">
		<div class="col-xl-12">
			<div class="m-form__section m-form__section--first">
				<!-- <div class="m-form__heading">
					<h4 class="m-form__heading-title">
						Contact &amp; Address Details
					</h4>
				</div> -->
				<div class="row padding-10">
					<div class="form-group m-form__group col-6">
						<div class='row'>
							<label class="col-xl-4 col-lg-4 col-form-label">
								Mobile Number :
							</label>
							<div class="col-xl-8 col-lg-8">
								<input type="number" name="phone" class="form-control m-input" maxlength="10" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
								 placeholder="Enter mobile number of Applicant" formControlName="phone" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
											event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
											57">
								<app-form-control-messages [control]="group.get('contactDetails').get('phone')" [name]="'Mobile Number'"></app-form-control-messages>
							</div>
							<div class='row'>
							</div>
						</div>
					</div>
					<div class="form-group m-form__group col-6 padding-0">
						<div class='row'>
							<label class="col-xl-4 col-lg-4 col-form-label">
								Email ID :

							</label>
							<div class="col-xl-8 col-lg-8">
								<input type="email" name="email" class="form-control m-input" placeholder="Enter email address of Applicant" formControlName="email">
								<app-form-control-messages [control]="group.get('contactDetails').get('email')" [name]="'Email ID'"></app-form-control-messages>
							</div>
						</div>
					</div>
				</div>
				<div formGroupName="permanentAddress">
					<div class="m-form__heading">
						<h3 class="m-form__heading-title">
							Permanent Address:
						</h3>
					</div>
					<div class="row padding-10">
						<div class="form-group m-form__group col-6">
							<div class="row">
								<label class="col-xl-4 col-lg-4 col-form-label">
									Address:
									<span class="red">*</span>
								</label>
								<div class="col-xl-8 col-lg-8">
									<textarea class="form-control m-input" placeholder="Enter Full Address of the Applicant" formControlName="address1" maxlength="200"
									 [disabled]="isChecked?'true':null"></textarea>
									<app-form-control-messages [control]="group.get('contactDetails').get('permanentAddress').get('address1')" [name]="'Address'"></app-form-control-messages>
								</div>
							</div>
						</div>
					</div>
					<div class="row padding-10">
						<div class="form-group m-form__group col-6 state-heigth">
							<div class='row'>
								<label class="col-xl-4 col-lg-4 col-form-label">
									Pincode:
									<span class="red">*</span>
								</label>
								<div class="col-xl-8 col-lg-8" style="padding-left:15px!important">
									<input type="text" name="name" maxlength="6" class="form-control m-input" placeholder="Enter the pincode" formControlName="pinCode"
									 [disabled]="isChecked?'true':null">
									<app-form-control-messages [control]="group.get('contactDetails').get('permanentAddress').get('pinCode')" [name]="'Pincode'"></app-form-control-messages>
								</div>
							</div>
						</div>
					</div>
					<div class="row padding-10">
						<div class="form-group m-form__group col-6 state-heigth">
							<div class="row">
								<label class="col-xl-4 col-lg-4 col-form-label">
									State/Union Territory:
									<span class="red">*</span>
								</label>
								<div class="col-xl-8 col-lg-8">
									<div class="input-group">
										<select class="form-control" (change)="getDistrictForPermanentAddress()" formControlName="state" [disabled]="isChecked?'true':null">
											<option value="" disabled selected>Select State/Union Territory</option>
											<option *ngFor="let state of states" [(ngValue)]="state.name">{{state.name}}</option>
										</select>
									</div>
									<app-form-control-messages [control]="group.get('contactDetails').get('permanentAddress').get('state')" [name]="'State/Union Territory'"></app-form-control-messages>
								</div>
							</div>
						</div>
					</div>
					<div class="row padding-10" formGroupName="districtDetails">
						<div class="form-group m-form__group col-6 state-heigth">
							<div class="row">
								<label class="col-xl-4 col-lg-4 col-form-label">
									District:
									<span class="red">*</span>
								</label>
								<div class="col-xl-8 col-lg-8">
									<div class="input-group">
										<select class="form-control" formControlName="district" (change)="getSubDistrictsInDistrictsForPermanentAddress()" [disabled]="isChecked?'true':null">
											<option value="" disabled selected>Select District</option>
											<option *ngFor="let district of districts" [ngValue]="district.name">{{district.name}}</option>
										</select>
									</div>
									<app-form-control-messages [control]="group.get('contactDetails').get('permanentAddress').get('districtDetails').get('district')"
									 [name]="'District'"></app-form-control-messages>
								</div>
							</div>
						</div>
						<div class="form-group m-form__group col-6 padding-0"></div>



						<!-- <div class="form-group m-form__group col-6 state-heigth"></div> -->
						<div class="form-group m-form__group col-6 state-heigth">
							<div class="row">
								<label class="col-xl-4 col-lg-4 col-form-label">
									Sub-District:
									<span class="red">*</span>
								</label>
								<div class="col-xl-8 col-lg-8">
									<div class="input-group">
										<select class="form-control" formControlName="subDistrict" (change)="getVillagesInSubDistrictforPemanent()" [disabled]="isChecked?'true':null">
											<option value="" disabled selected>Sub-District</option>
											<option *ngFor="let subdistricts of subDistricts" [ngValue]="subdistricts.name">{{subdistricts.name}}</option>
										</select>
									</div>
									<app-form-control-messages [control]="group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrict')"
									 [name]="'Sub-District'"></app-form-control-messages>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group m-form__group col-6 state-heigth">
						<div class="row">
							<label class="col-xl-4 col-lg-4 col-form-label">
								Village/Town/City:
								<span class="red">*</span>
							</label>
							<div class="col-xl-8 col-lg-8" style="padding-left:5px!important">
								<select class="form-control" formControlName="city" [disabled]="isChecked?'true':null">
									<option value="" disabled selected>Select Village/Town/City</option>
									<option *ngFor="let village of villageOptions" [(ngValue)]="village.name">{{village.name}}</option>
								</select>

								<app-form-control-messages [control]="group.get('contactDetails').get('permanentAddress').get('city')" [name]="'Village/Town/City'"></app-form-control-messages>
							</div>
						</div>
					</div>
					<div class="form-group m-form__group col-6 state-heigth" formGroupName="districtDetails">
						<div class="row">
							<label class="col-xl-4 col-lg-4 col-form-label">
								Parliamentary Constituency:
								<span class="red">*</span>
							</label>
							<div class="col-xl-8 col-lg-8">
								<div class="input-group">
									<select class="form-control" formControlName="parliamentaryConstituency" [disabled]="isChecked?'true':null">
										<option value="" disabled selected>Select Parliamentary Constituency</option>
										<option *ngFor="let parliament of parliaments" [ngValue]="parliament.name">{{parliament.name}}</option>
									</select>
								</div>
								<app-form-control-messages [control]="group.get('contactDetails').get('permanentAddress').get('districtDetails').get('parliamentaryConstituency')"
								 [name]="'Parliamentary Constituency'"></app-form-control-messages>
							</div>
						</div>
					</div>

					<div class="row padding-10">
					</div>
				</div>

				<div formGroupName="communicationAddress">
					<div class="m-form__heading">
						<h3 class="m-form__heading-title">
							Communication Address:
						</h3>
						<h3 class="m-form__heading-title">
							Same as Permanent Address:
							<label class="m-checkbox m-checkbox--default">
								<input type="checkbox" (change)="workAsPermanentAddress(register.checked)" [(ngModel)]="isSameAsPermanetAddress" [disabled]="!group.get('contactDetails').get('permanentAddress').valid"
								 [ngModelOptions]="{standalone: true}" #register>
								<span style="margin-left: 10px!important;top:-5px!important;"></span>
							</label>
						</h3>
					</div>
					<div>
						<div class="row padding-10">
							<div class="form-group m-form__group col-6">
								<div class="row">
									<label class="col-xl-4 col-lg-4 col-form-label">
										Address:
										<span class="red">*</span>
									</label>
									<div class="col-xl-8 col-lg-8">
										<textarea class="form-control m-input" [disabled]="isChecked?'true':null" placeholder="Enter Full Address of the Applicant"
										 formControlName="address1" maxlength="200"></textarea>
										<app-form-control-messages [control]="group.get('contactDetails').get('communicationAddress').get('address1')" [name]="'Address'"></app-form-control-messages>
									</div>
								</div>
							</div>

						</div>
						<div class="row padding-10">
							<div class="form-group m-form__group col-6 state-heigth">
								<div class='row'>
									<label class="col-xl-4 col-lg-4 col-form-label">
										Pincode:
										<span class="red">*</span>
									</label>
									<div class="col-xl-8 col-lg-8" style="padding-left:15px!important">
										<input type="text" name="pc" [disabled]="isChecked?'true':null" maxlength="6" class="form-control m-input" placeholder="Enter the pincode"
										 formControlName="pinCode">
										<app-form-control-messages [control]="group.get('contactDetails').get('communicationAddress').get('pinCode')" [name]="'Pincode'"></app-form-control-messages>
									</div>
								</div>
							</div>
						</div>
						<div class="row padding-10">
							<div class="form-group m-form__group col-6 state-heigth">
								<div class="row">
									<label class="col-xl-4 col-lg-4 col-form-label">
										State/Union Territory:
										<span class="red">*</span>
									</label>
									<div class="col-xl-8 col-lg-8">
										<div class="input-group">
											<select class="form-control" formControlName="state" [disabled]="isChecked?'true':null" (change)="getDistrictForCurrentAddress()">
												<option value=null disabled selected>Select State/Union Territory </option>
												<option *ngFor="let state of states" [ngValue]="state.name">{{state.name}}</option>
											</select>
										</div>
										<app-form-control-messages [control]="group.get('contactDetails').get('communicationAddress').get('state')" [name]="'State/Union Territory'"></app-form-control-messages>

									</div>
								</div>
							</div>


						</div>

						<div formGroupName="districtDetails" class="row padding-10">
							<div class="form-group m-form__group col-6 state-heigth">
								<div class="row">
									<label class="col-xl-4 col-lg-4 col-form-label">
										District:
										<span class="red">*</span>
									</label>
									<div class="col-xl-8 col-lg-8">
										<div class="input-group">
											<select class="form-control" formControlName="district" [disabled]="isChecked?'true':null" (change)="getSubDistrictsInDistrictsForCurrentAddress()">
												<option value=null disabled selected>Select District </option>
												<option *ngFor="let districts of districtsForCurrentAddress" [ngValue]="districts.name">{{districts.name}}</option>
											</select>
										</div>
										<app-form-control-messages [control]="group.get('contactDetails').get('communicationAddress').get('districtDetails').get('district')"
										 [name]="'District'"></app-form-control-messages>
									</div>
								</div>
							</div>
							<div class="form-group m-form__group col-6 state-heigth"></div>

							<!-- <div class="form-group m-form__group col-6 state-heigth"></div> -->
							<div class="form-group m-form__group col-6 state-heigth">
								<div class="row">
									<label class="col-xl-4 col-lg-4 col-form-label">
										Sub-District:
										<span class="red">*</span>
									</label>
									<div class="col-xl-8 col-lg-8">
										<div class="input-group">
											<select class="form-control" formControlName="subDistrict" [disabled]="isChecked?'true':null" (change)="getVillagesInSubDistrictforCurrent()">
												<option value=null disabled selected>Select Sub-District</option>
												<option *ngFor="let subdistricts of subdistrictsForCurrentAddress" [ngValue]="subdistricts.name">{{subdistricts.name}}</option>
											</select>
										</div>
										<app-form-control-messages [control]="group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrict')"
										 [name]="'Sub-District'"></app-form-control-messages>
									</div>
								</div>
							</div>

						</div>
						<div class="form-group m-form__group col-6 state-heigth">
							<div class="row">
								<label class="col-xl-4 col-lg-4 col-form-label">
									Village/Town/City:
									<span class="red">*</span>
								</label>
								<div class="col-xl-8 col-lg-8" style="padding-left:5px!important">
									<select class="form-control" formControlName="city" [disabled]="isChecked?'true':null">
										<option value="" disabled selected>Select Village/Town/City</option>
										<option *ngFor="let village of villageOptionsForCommunication" [(ngValue)]="village.name">{{village.name}}</option>
									</select>

									<app-form-control-messages [control]="group.get('contactDetails').get('communicationAddress').get('city')" [name]="'Village/Town/City'"></app-form-control-messages>
								</div>
							</div>
						</div>
						<div class="form-group m-form__group col-6 state-heigth" formGroupName="districtDetails">
							<div class="row">
								<label class="col-xl-4 col-lg-4 col-form-label">
									Parliamentary Constituency:
									<span class="red">*</span>
								</label>
								<div class="col-xl-8 col-lg-8">
									<div class="input-group">
										<select class="form-control" formControlName="parliamentaryConstituency" [disabled]="isChecked?'true':null">
											<option value=null disabled selected>Select Parliamentary Constituency</option>
											<option *ngFor="let parliament of parliamentsCommunication" [ngValue]="parliament.name">{{parliament.name}}</option>
										</select>
									</div>
									<app-form-control-messages [control]="group.get('contactDetails').get('communicationAddress').get('districtDetails').get('parliamentaryConstituency')"
									 [name]="'Parliamentary Constituency'"></app-form-control-messages>
								</div>
							</div>
						</div>

						<div class="row padding-10">


						</div>
					</div>
				</div>


			</div>
		</div>
	</div>
</div>
